import { Link as RouterLink } from 'react-router-dom';

// material-ui
import { Link } from '@mui/material';

// project imports
import { DASHBOARD_PATH } from '../../../config';
import GLMLogo from 'ui-component/GLMLogo';

// ==============================|| MAIN LOGO ||============================== //

const GLMLogoSection = () => (
    <Link component={RouterLink} to={DASHBOARD_PATH}>
        <GLMLogo sx={{ width: '175px', height: '40px' }} />
    </Link>
);

export default GLMLogoSection;
